/**
 * BadBottleWarning — yellow banner for anomalous result (bonus A).
 *
 * Pure presentational — TestRunnerModal orchestrates the decision logic.
 */
export interface BadBottleWarningProps {
  deltaSigma: number;
  mean: number;
  unit: string;
  onConfirmSave(): void;
  onRetest(): void;
}

export function BadBottleWarning({
  deltaSigma,
  mean,
  unit,
  onConfirmSave,
  onRetest,
}: BadBottleWarningProps) {
  return (
    <div className="my-4 p-4 bg-yellow-500/10 border border-yellow-500/50 rounded-lg">
      <div className="flex items-start gap-3">
        <svg
          aria-hidden="true"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-yellow-400 shrink-0 mt-0.5"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <div className="text-sm text-yellow-300">
          <p className="font-semibold mb-1">
            &#9888;&#65039; This reading is {deltaSigma.toFixed(1)}&sigma;
            {" "}outside your 7-day average of {mean.toFixed(2)} {unit}.
          </p>
          <p className="text-yellow-400/80">
            Bad reagent? Mis-measured? You can save this result or retest.
          </p>
        </div>
      </div>
      <div className="flex gap-3 mt-4">
        <button
          onClick={onRetest}
          className="flex-1 px-4 py-2 rounded-md text-sm font-semibold bg-slate-600 text-slate-200 hover:bg-slate-500 transition-colors"
        >
          Re-test
        </button>
        <button
          onClick={onConfirmSave}
          className="flex-1 px-4 py-2 rounded-md text-sm font-semibold bg-yellow-600 text-white hover:bg-yellow-500 transition-colors"
        >
          Save anyway
        </button>
      </div>
    </div>
  );
}
